module.exports = __webpack_public_path__ + "static/media/ramadhan_promo.de5611a4.jpeg";